module.exports = __webpack_public_path__ + "static/favicon-16x16.png";


//////////////////
// WEBPACK FOOTER
// ./src/examples/shared/favicon/favicon-16x16.png
// module id = 511
// module chunks = 0